




































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { DxButton, DxPopup,DxTagBox, DxSelectBox, DxTextBox, DxCheckBox, DxScrollView, DxTabs, DxLoadPanel as LoadPanel } from 'devextreme-vue';
import DxToolbar from 'devextreme-vue/toolbar';
import {DxForm, DxItem, DxAsyncRule, DxStringLengthRule,DxSimpleItem} from 'devextreme-vue/form';
import CustomStore from 'devextreme/data/custom_store';
import { AgentService } from '../../service/AgentService';
import { ClientDto } from '@/models/client/ClientDto';
import { AgentInfoDto } from '@/models/agent/AgentInfoDto';
import { FeeSheetEmailerWizardDto } from '@/models/Fees/FeeSheetEmailerWizardDto';
import { ClientAgentJurisdictionDto, JurisdictionType } from '@/models/client-agent/ClientAgentJurisdictionDto';
import { CountryDto } from '../../models/CountryDto';
import { DxToolbarItem } from 'devextreme-vue/popup';
import Form from "devextreme/ui/form";
import _ from "lodash";
import  FeeSheetRowDialog  from './fee-sheet-row-dialog.vue'
import { DxHtmlEditor } from 'devextreme-vue/html-editor';
import dialog from 'devextreme/ui/dialog';
import EmailTemplateEditor from './email-template-editor.vue'
import EmailFeeSheetPreview from './email-fee-sheet-preview.vue'

import DataGrid from "devextreme/ui/data_grid";
import {
  DxDataGrid,
  DxColumn,
  DxColumnFixing,
  DxEditing,
  DxFormItem,
  DxHeaderFilter,
  DxFilterRow,
  DxSelection,
  DxScrolling,
  DxLoadPanel,
  DxLookup
} from 'devextreme-vue/data-grid';
import DevExpress from 'devextreme';
import DxValidator, { DxRequiredRule } from 'devextreme-vue/validator';
import { Popup } from '@questelservices/common-vue';
import { FeeSheetsService } from '../../service/FeeSheetsService';
import { FeeSheetDto } from '@/models/Fees/FeeSheetDto';
import { EmailInstructionDto } from '@/models/EmailInstructionDto';
import { AgentFeeSheetTableDto, AgentFeeSheetTableColumnDto } from '@/models/audit/AgentFeeSheetTableDto';
import { AgentFeeSheetTableDetailEnum, AgentFeeSheetDetailColorEnum } from '@/models/audit/AgentFeeSheetTableDetailEnum';
import { TextTemplateService } from '@/service/TextTemplateService';
import { TextTemplateTypeEnum } from '@/models/TextTemplateTypeEnum';
import Tabs from "devextreme/ui/tabs";
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { getModule } from 'vuex-module-decorators';
import CommonModule from '@questelservices/common/dist/store/CommonModule';
import store from '@/store';
import { SendFeeSheetDto } from '@/models/Fees/SendFeeSheetDto';
import { SendAgentFeeSheetDto } from '@/models/Fees/SendAgentFeeSheetDto';
import notify from 'devextreme/ui/notify';


const commonState = getModule(CommonModule, store);

@Component({
  components: {
    Popup,
    DxForm,
    DxItem,
    DxButton,
    DxLookup,
    DxSelectBox,
    DxToolbar,
    DxToolbarItem,
    DxStringLengthRule,
    DxAsyncRule,
    DxSimpleItem,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxDataGrid,
    FeeSheetRowDialog,
    DxCheckBox,
    DxTextBox,
    DxValidator,
    DxRequiredRule,
    DxScrollView,
    DxFilterRow,
    DxSelection,
    DxTabs,
    DxScrolling,
    DxLoadPanel,
    DxHtmlEditor,
    EmailTemplateEditor,
    EmailFeeSheetPreview,
    DxColumnFixing,
    LoadPanel,
    DxTagBox
    
  }
})
export default class FeeSheetEmailerWizards extends Vue {
    $refs: Vue['$refs'] & {
        agentFeeSheetsTo?: DataGrid;
        agentFeeSheets?: DataGrid;
        emailGrid?: DataGrid;
        wizardStepper? : Tabs;
    } = {};

    @Prop()
    client!: ClientDto;

   
    get ClientVal() {
        return this.client;
    }
    
    get agentFeeSheetsToGrid() {
        return (this.$refs.agentFeeSheetsTo as DataGrid).instance;
    }

    get agentFeeSheetsGrid() {
        return (this.$refs.agentFeeSheets as DataGrid).instance;
    }

    get emailInsGrid() {
        return (this.$refs.emailGrid as DataGrid).instance;
    }

    get wizardStepperComponent() {
        return ((this.$refs.wizardStepper as Tabs).instance as any);
    }

    agentFromCustomStoreOptions: CustomStore;
    selectedRows: any[] = [];
    emailInstruction: EmailInstructionDto[] = [] 
    wizardStep: number = 0;
    prevStep:number = 0;
    fromToolbarItem: boolean = false;
    agentService : AgentService;
    feeSheetService : FeeSheetsService;
    cancelOrBack: string = "Cancel";
    continueOrFinish: string = "Continue";
    showEmailTemplate: boolean = false;
    showPreview: boolean = false;
    previewDisplay: string = "";
    forFeeSheetPreview: boolean = false;
    tabs = [
      {
        id : 0,
        text : 'Select Agents',
        icon: 'user'
      },
      {
        id : 1,
        text : 'Select Fee Sheets',
        icon: 'card',
        disabled: true
      },
      {
        id : 2,
        text : 'Select Templates',
        icon: 'message',
        disabled: true
      }
    ]
    emailTemplateList: any = [];
    instructionTemplateList: any = [];

    get selectedRowAgentId() {
      return this.selectedRows.map(item => item.AgentId);
    }

    feeSheetColumns: any[] = [];

    get columns() : any[] {    
      return this.feeSheetColumns;
    }

    agentsFeeSheets: FeeSheetDto[] = [];
    
    get AgentFeeSheets() : any {
      let result: any = [];
      
      if(this.agentsFeeSheets && this.agentsFeeSheets.length > 0) {
        result = this.processData(this.agentsFeeSheets.filter(afs => afs.ClientId === this.ClientVal.ClientId));
      }

      return new DataSource({
            store: new ArrayStore({
              key : "AgentName",
              data: result
            })
        });
    }

    emailInstructionList: EmailInstructionDto[] = [];
    get emailInstructionGrid() : any {
      return {
        "store" : {
          "type": 'array',
          "key" : 'AgentName',
          "data" : this.emailInstructionList
        }
      }
    }

    sendingInProgress: boolean = false;
    textTemplateService: TextTemplateService;
    feeSheetEmailHeaderStore: CustomStore;
    feeSheetInstructionsStore: CustomStore;
    defaultHeaderStore(type: TextTemplateTypeEnum) {
      return new CustomStore({
          loadMode: 'raw',
          load: (options): Promise<any> => {
          return this.textTemplateService.getTextTemplate(type)
              .then((results : any) => {
                  return results;
              }
              
              )
              .catch(err=> []);
          }
      });
    }

    constructor() {
        super();
        
        this.showDialog = false;
        this.agentService = new AgentService();
        this.feeSheetService = new FeeSheetsService('/api/FeeSheets');
        this.agentFromCustomStoreOptions = new CustomStore();
        this.textTemplateService = new TextTemplateService();
        this.feeSheetEmailHeaderStore = this.defaultHeaderStore(TextTemplateTypeEnum.FeeSheetEmail);
        this.feeSheetInstructionsStore = this.defaultHeaderStore(TextTemplateTypeEnum.FeeSheetInstructions);
        
    }
    
    @Prop({ default: false })
    showDialog!: boolean;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value:boolean) {
        this.hidingModal();
    }

    onTemplateEditorHidden(e:any) {
      this.showEmailTemplate = false;
      this.feeSheetEmailHeaderStore = this.defaultHeaderStore(TextTemplateTypeEnum.FeeSheetEmail);
      this.feeSheetInstructionsStore = this.defaultHeaderStore(TextTemplateTypeEnum.FeeSheetInstructions);
    }
    async onSelectionChanged(e:any) {
      
      if(!this.fromToolbarItem) {
        let canContinue = true;
        this.prevStep = this.wizardStep;
        this.wizardStep = e.component.instance().option("selectedIndex");

        if(this.wizardStep == 1) {
          let fromStep3 = this.prevStep > this.wizardStep;
          this.continueOrFinish = "Continue";
          this.cancelOrBack = "Back";

          if(!fromStep3) {
            this.wizardStepperComponent.option("items[2].disabled", true);
          }
          // else {
            await this.processStep2Data(fromStep3);
          // }
        }
        else if(this.wizardStep == 2) {
          this.continueOrFinish = "Finish";
          this.cancelOrBack = "Back";
          
          await this.processStep3Data();
        }
        else {
          this.continueOrFinish = "Continue";
          this.cancelOrBack = "cancel";
          this.wizardStepperComponent.option("items[2].disabled", true)
        }
      }
      this.fromToolbarItem = false;
    }

    onOpenedEmailCC(e:any) {
            e.component.content().remove();
    }

    emailCCSource: string[] = [""];
    selectedEmailCC: string[] = [];
    duplicateCustomItem: string = ""
    emailCCHasError: boolean = false;
    validationRule = {
            invalidEmail : {
                type: 'email',
                message : 'Invalid email'
            },
            noError : {}
    }
      onCustomItemCreatingEvent(e:any) {
          if (this.checkEmailValidation(e.text))
          {
              let name = e.component.option("name");

              if(name == "emailCCComponent")
              {
                  if(_.find(this.emailCCSource, item => item === e.text)) {
                      this.duplicateCustomItem = e.text;
                  }
                  else {
                      this.emailCCSource.push(e.text);
                  }
              }
              this.emailCCHasError = false;
          }
          else {
              this.emailCCHasError = true;
              e.component.option("isValid", false)
              e.component.option("validationError",this.validationRule.invalidEmail)
          }
      }

    tagItemStyle(e:any) {
        return {
            'background-color' : this.checkEmailValidation(e) ? '#e0e0e0' : '#f5b5b5'
        }
    }

      onEmailCCValueChanged(e:any) {
            if(this.duplicateCustomItem){
                let val = e.component.option("value");

                val.push(this.duplicateCustomItem);
                e.component.option("value", val);

                this.duplicateCustomItem = "";
            }
            if(e.value && e.value.length > 0) {
                if(_.find(e.value,item => !(this.checkEmailValidation(item)))) {
                    this.emailCCHasError = true;
                    e.component.option("isValid", false)
                    e.component.option("validationError",this.validationRule.invalidEmail)
                }
                else {
                    this.emailCCHasError = false;
                    e.component.option("isValid", true)
                    e.component.option("validationError", null)
                }
            }
            else {
                    this.emailCCHasError = false;
                    e.component.option("isValid", true)
                    e.component.option("validationError", null)
            }
        }

      checkEmailValidation(text: string) {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(text)
      }

    async onPreviewEmailClicked(e:any) {
      this.forFeeSheetPreview = false;
      if(!e.data.EmailTemplateId) {
        await dialog.alert("Please select email template first.", "Required");
      }
      else {
        let toDisplay = await this.textTemplateService.getTextTemplateById(e.data.EmailTemplateId)
                    .then(result => result.Text)
                    .catch(err => "");
        
        this.previewDisplay = this.processActualTokenData(toDisplay, e.data);
        this.showPreview = true;
      }
    }

    selectedFeeSheetIds: Guid[] = [];
    feeSheetInstructionId: Guid = "";
    async onPreviewFeeSheetClicked(e:any) {
      this.forFeeSheetPreview = true;
      if(!e.data.InstructionTemplateId) {
        await dialog.alert("Please select instruction template first.", "Required");
      }
      else {
        var feeSheetsHTML = await this.feeSheetService.getExportFeeSheetsHTML(e.data.FeeSheetIds);
        var toDisplay = await this.textTemplateService.getTextTemplateById(e.data.InstructionTemplateId)
                    .then(result => result.Text)
                    .catch(err => "");
        
        this.previewDisplay = this.processActualTokenData(toDisplay, e.data) + '<br /><br />' + feeSheetsHTML;
        this.selectedFeeSheetIds = e.data.FeeSheetIds;
        this.feeSheetInstructionId = e.data.InstructionTemplateId;
        this.showPreview = true;
      }
    }

    processActualTokenData(toDisplay: string, data: any) {
      let result = "";
      result = toDisplay;
      if(result.includes("[AGENTNAME]")) {
        result = result.split('[AGENTNAME]').join(data.AgentName);
      }
      if(result.includes("[CLIENTNAME]")) {
        result = result.split('[CLIENTNAME]').join(this.ClientVal.ClientName);
      }

      return result;
    }

    widthValue = 250;
    private onCellPrepared(e: any): void {     
      if(e.rowType === 'header') {
        return;
      }

      if(e.rowType === 'data' && e.column.dataField !== "AgentName" && !e.column.dataField.includes("_selection")) {          
          let obj = e.row.data;        
          if(obj.hasOwnProperty(e.column.dataField)) { 
            e.cellElement.style['background-color'] =  this.getColor(e.row.data[e.column.dataField]);
          }
          else { 
            e.cellElement.style['background-color'] = AgentFeeSheetDetailColorEnum.Blank;
          }

          e.cellElement.style['width'] = this.widthValue;
          
      }
      else if(e.column.dataField.includes("_selection")){          
          e.cellElement.style['background-color'] = "white";
          e.cellElement.style['width'] = '30px';
      }
    }

    private getColor(value: string): AgentFeeSheetDetailColorEnum {      
      if(value.includes('Signed') && value.includes('/')) {
        return AgentFeeSheetDetailColorEnum.SignedXY;
      }

      if(value.includes('Signed')) {
        return AgentFeeSheetDetailColorEnum.Signed
      }

      switch(value) {
        case AgentFeeSheetTableDetailEnum.NotSigned:
          return AgentFeeSheetDetailColorEnum.NotSigned;          
        case AgentFeeSheetTableDetailEnum.NotYetSent:
          return AgentFeeSheetDetailColorEnum.NotYetSent;
      }
      
      return AgentFeeSheetDetailColorEnum.Blank;
    }

    onStep3CellPrepared(e: any) {
      if(e.rowType === 'data' && (e.column.dataField === "AgentName")) {
          let obj = e.row.data;        
          if(!e.row.data.AgentName) { 
            e.cellElement.style['border-right'] = "2px solid transparent";
          }
      }
    }

    onContentReady(e: any) {
      if(e.component) {
        this.selectionColumnIndexes.forEach(index => {
          e.component.columnOption(index,"caption", "");
          e.component.columnOption(index,"width", 70);
          
        })
        
      }
    }

    onEditingStart(e:any) {
      if(e.column.dataField.includes("_selection")) {
        let prop = e.column.dataField;
        if(e.data[prop] != undefined) {
          e.cancel = false;
        }
        else {
          e.cancel = true;
        }

      }
    }

    selectedRowInContextMenu: any = {
      data : false,
      prop : ""
    };

    onRowStep2Updated(e:any) {
      let dataSource = (this.agentFeeSheetsGrid as any).getDataSource().items();
      
      this.processEnableAndDisableStep3(dataSource);
    }

    hasSelectedStep2Grid(dataSource: any[]) : boolean {
      let result = false;

      this.columns
      .filter((element: any) => element.name.includes("_selection"))
      .forEach((element: any) => {
        if(dataSource.find((x:any) => x[element.name] == true)) {
          result = true;
        }
      });
      return result;
    }
    prepareContextMenu(e: any) {
      if(e.row.rowType && e.row.rowType === "data" && e.column.dataField.includes("_selection"))
      {
        let prop = e.column.dataField;
        
        if(e.row.data[prop] != undefined) {
          this.selectedRowInContextMenu.data = e.row.data[prop];
          this.selectedRowInContextMenu.prop = prop;

          e.items = [
            { text: e.row.data[prop] ? "Unselect All" : "Select All",
              onItemClick: this.onContextMenuClick
            }
          ]
        }
      }
    }

    edittedColumn: string = '';
    saveCellEdit(e: any) {
      this.edittedColumn = 'EmailTemplateId';
      (this.emailInsGrid as any).saveEditData();
    }
    saveCellInstructionEdit(e:any) {
      this.edittedColumn = 'InstructionTemplateId';
      (this.emailInsGrid as any).saveEditData();
    }
    onRowUpdated(e: any) {
      if(e.key != undefined) {
        let data = e.data;
        let dataSource = (this.emailInsGrid as any).getDataSource().items();

        if(e.key === '') {
          dataSource.forEach((element:any) => {
            if(element.AgentName) {
              element[this.edittedColumn] = data[this.edittedColumn]
            }
          });
        }
        else {
          let first = dataSource[0];
          first[this.edittedColumn] = undefined;
        }

        (this.emailInsGrid as any).option("dataSource", {
          "store" : {
            "type": 'array',
            "key" : 'AgentName',
            "data" : dataSource
          }
        })
      }
    }
    onContextMenuClick() {
      let dataSource = (this.agentFeeSheetsGrid as any).getDataSource().items();
      let rowData = this.selectedRowInContextMenu.data;
      let prop = this.selectedRowInContextMenu.prop;

      dataSource.forEach((element : any) => {
        if(element.hasOwnProperty(prop)) {
          element[prop] = rowData ? false: true;
        }
      });

      (this.agentFeeSheetsGrid as any).option("dataSource", dataSource)
      this.processEnableAndDisableStep3(dataSource);
      
    }

    processEnableAndDisableStep3(dataSource: any) {
      let hasSelected = this.hasSelectedStep2Grid(dataSource);
      if(hasSelected) {
        this.wizardStepperComponent.option("items[2].disabled", false)
      }
      else {
        this.wizardStepperComponent.option("items[2].disabled", true)
      }
    }

    processEmailInstructionData(): Promise<EmailInstructionDto[]> {
      let result : EmailInstructionDto[] = [];

      let firstElement : EmailInstructionDto = {
          AgentName : "",
          FeeSheetToSend : "",
          FeeSheetIds: []
      }

      if(this.$refs.agentFeeSheets) {
        let dataSource = (this.agentFeeSheetsGrid as any).getDataSource().items();
        let columnSelections = this.columns.filter((element: any) => element.name.includes("_selection"));

        dataSource.forEach((element: any) => {
          let emailInstruction : EmailInstructionDto = {
            AgentName : element.AgentName,
            FeeSheetToSend : "",
            FeeSheetIds: []
          }
          let feeSheetNamesToSend: string[] = [];
          columnSelections.forEach((x:any) =>{ 
            if(element[x.name] == true) {
              let fSheetName = x.name.replace('_selection', '');
              emailInstruction.FeeSheetToSend += `${fSheetName}<br />`
              feeSheetNamesToSend.push(fSheetName)
            }
          })

          if(emailInstruction.FeeSheetToSend) {
            emailInstruction.FeeSheetIds = this.agentsFeeSheets
                                          .filter(x => x.Agent && x.Agent.AgentName == element.AgentName &&
                                                 feeSheetNamesToSend.includes(x.FeeSheetName))
                                          .map(x => x.FeeSheetId)
            result.push(emailInstruction)
          }
        });
      }
      
      result.unshift(firstElement);

      return Promise.resolve(result);
    }
   
    selectionColumnIndexes: number[] = []
    processColumns(agentsFeeSheets : any) {
      this.feeSheetColumns = [];
      let tempColumns : any = [];
      this.selectionColumnIndexes = []
      
      let columnIndex = 0;
      _.uniqBy(agentsFeeSheets, (c : any) => c.FeeSheetName).forEach(item => {
        let column = {"name":item.FeeSheetName, "type" : "string", "isEditable" : false}
        let column1 = {"name":`${item.FeeSheetName}_selection`, "type" : "boolean", "isEditable" : true}

        tempColumns.push(column);
        tempColumns.push(column1);
        columnIndex += 2;

        this.selectionColumnIndexes.push(columnIndex);
      })
      this.feeSheetColumns = tempColumns;
    }

    processData(agentsFeeSheets : any): AgentFeeSheetTableDto[] {
      let result: AgentFeeSheetTableDto[]= [];
      let agentsWithoutFeeSheets: AgentFeeSheetTableDto[] = [];    

      this.selectedRows.forEach(agent => {
        let tableRow: AgentFeeSheetTableDto = {
          AgentName: agent.AgentName,
          Colors: [] as AgentFeeSheetDetailColorEnum[],
          FeeSheetIds: [] as Guid[]
        };  

        let count = _.uniqBy(agentsFeeSheets,(item : any) => item.FeeSheetName).length;
        for(var i = 0; i < count; i++) {
          agentsFeeSheets
          .filter((item : any) => item.AgentName && item.AgentName == agent.AgentName)
          .forEach((item : any, ind: number, arr: any[]) => {
              let agentFeeSheet = item;

              if(agentFeeSheet) {
                tableRow.FeeSheetIds.push(agentFeeSheet.FeeSheetId);

                let tableColumn : AgentFeeSheetTableColumnDto = {
                  Signed: agentFeeSheet.Signed,
                  Modified: agentFeeSheet.Modified,
                  EffectiveDate : (this.$options.filters as any).moment(agentFeeSheet.EffectiveDate,"DD MMM YYYY"),
                  LastSentDate : agentFeeSheet.LastSentDate ? 
                  (this.$options.filters as any).moment(agentFeeSheet.LastSentDate,"DD MMM YYYY"):undefined           
                };
                let modifiedString = agentFeeSheet.Modified ? "Modified" : "";

                if(agentFeeSheet.Signed === "Yes") {
                  if(agentFeeSheet.EffectiveDate) {
                    tableRow[agentFeeSheet.FeeSheetName] = `${AgentFeeSheetTableDetailEnum.Signed} ${modifiedString} ${tableColumn.EffectiveDate}`; 
                  }                  
                  tableRow.Colors.push(AgentFeeSheetDetailColorEnum.Signed);
                }
                else if(agentFeeSheet.Signed !== "Yes" && agentFeeSheet.Signed !== "No"){
                  let signedDetail = agentFeeSheet.Signed.replace(' of ','/');
                  let detail = AgentFeeSheetTableDetailEnum.SignedXY.replace('X/Y', signedDetail);

                  if(agentFeeSheet.EffectiveDate) {
                    tableRow[agentFeeSheet.FeeSheetName] = `${detail} ${modifiedString} ${tableColumn.EffectiveDate}`;  
                  }              
                  tableRow.Colors.push(AgentFeeSheetDetailColorEnum.SignedXY);
                }
                else if(agentFeeSheet.Signed === "No") {
                  if(!agentFeeSheet.LastSentDate){
                    tableRow[agentFeeSheet.FeeSheetName] = AgentFeeSheetTableDetailEnum.NotYetSent;
                    tableRow.Colors.push(AgentFeeSheetDetailColorEnum.NotYetSent);
                  }   
                  else {
                    tableRow[agentFeeSheet.FeeSheetName] = AgentFeeSheetTableDetailEnum.NotSigned;
                    tableRow.Colors.push(AgentFeeSheetDetailColorEnum.NotSigned);
                  }
                  
                }
                
                
                tableRow[`${agentFeeSheet.FeeSheetName}_selection`] = false;
              }      
              else {
                tableRow.FeeSheetIds.push("");
                tableRow.Colors.push(AgentFeeSheetDetailColorEnum.Blank);
              }
          });
        }

        if(tableRow.FeeSheetIds.every(id => id == "")) {
            agentsWithoutFeeSheets.push(tableRow);
          }
        else {
            result.push(tableRow);
        }
      });
      
      result = _.orderBy(result, a => a.AgentName);
      agentsWithoutFeeSheets = _.orderBy(agentsWithoutFeeSheets, a => a.AgentName);
      result = result.concat(agentsWithoutFeeSheets);

      return result;
  }  

    onUpdateTemplates(e: any) {
      this.showEmailTemplate = true;
    }
   

    hidingModal() :void {
        this.$emit("hiding");
    }

    step1Selection: any;
   async onStep1SelectionChanged(e:any) {
      this.step1Selection = await (this.agentFeeSheetsToGrid as any).getSelectedRowsData()
              .then((success : any) => success)
              .catch((err: any) => []);

      if(this.step1Selection.length > 0) {
        this.wizardStepperComponent.option("items[1].disabled", false)
      }
      else {
        this.wizardStepperComponent.option("items[1].disabled", true)
      }
    }

    contentReady(e: any) {
        if (e.component.shouldSkipNextReady) {
            e.component.shouldSkipNextReady = false;
        } else {
            e.component.shouldSkipNextReady = true;
            e.component.columnOption('command:select', 'width', 40);
            e.component.updateDimensions();
        }
    }

   get agentToCustomStoreOptions() {
     if(this.showDialog) {
      return new CustomStore({       
              key: 'AgentId',
              load: (options): Promise<any> => {
                if(this.client && this.client.ClientId) {
                  return this.agentService
                      .agentInfo(options, this.client.ClientId)
                      .then((result: any) => {
                          return result.data;                                 
                      })
                      .catch(err => {
                          return [];
                      });
                }
                else {
                  return Promise.resolve([]);
                }
              }            
          });
     }
     else {
       return []
     }
   }

    async processStep2Data(fromStep3: boolean) : Promise<boolean> {
      let canContinue : boolean = true;

      if(!fromStep3) {
        this.selectedRows = await (this.agentFeeSheetsToGrid as any).getSelectedRowsData()
          .then((success : any) => success)
          .catch((err: any) => []);

        if(this.selectedRows.length === 0) {
          await dialog.alert("Select at least one agent to continue.", "Required");
          canContinue = false;
        }
        else {
          this.agentsFeeSheets = await this.feeSheetService.getFeeSheetsStatus(this.client.ClientId, 
              this.selectedRows.map((item : any)=>item.AgentId))
              .then(result => {
                result = _.orderBy(result, ["FeeSheetName"],["asc"]);
                this.processColumns(result.filter(afs => afs.ClientId === this.ClientVal.ClientId));

                return result;
              })
              .catch(err => err);
        }
      }
      return Promise.resolve(canContinue);
    }

    async processStep3Data() : Promise<boolean> {
      let canContinue : boolean = true;
      let dataSource = (this.agentFeeSheetsGrid as any).getDataSource().items();
        
      let hasSelected = this.hasSelectedStep2Grid(dataSource);
      
      if(!hasSelected) {
        await dialog.alert("Select at least one fee sheet to continue.", "Required");
        canContinue = false;
      }
      else{
        (this.emailInsGrid as any).beginCustomLoading();
        this.emailInstructionList = await this.processEmailInstructionData();
        (this.emailInsGrid as any).endCustomLoading();
      }

      return Promise.resolve(canContinue);
    }

    async processDisplayMissingEmailAndFeeSheetId(dataSourceItems: any) {
      var agentWithMissingTemplate = "";

      dataSourceItems.filter((item : any)=> !item.InstructionTemplateId || !item.EmailTemplateId)
      .forEach((element : any) => {
        agentWithMissingTemplate += `<b>${element.AgentName}</b><br />`
      });;

      await dialog.alert(`Please select an email template and a fee sheet template for all agents.<br />
                          Agents missing a template selection:<br />
                          ${agentWithMissingTemplate}`, "Required");
    }

    async processConfirmationToSend(dataSourceItems: any) {
      var agentsWithFeeSheet: any = [];
      var displayMessage = "";
      dataSourceItems.forEach((element : any) => {
        let aWf = {
          "AgentName" : element.AgentName,
          "FeeSheetsSelected" : element.FeeSheetToSend.split("<br />")
                                .sort()
        }
        aWf.FeeSheetsSelected.shift();
        aWf.FeeSheetsSelected = aWf.FeeSheetsSelected.join(", ");

        agentsWithFeeSheet.push(aWf);
      });
      let groupedItems = _.groupBy(agentsWithFeeSheet, i => i.FeeSheetsSelected);

      let toDisplay = _.map(groupedItems,(feeSheetGroup, key) => {
        let feeSheets = key.split(", ");
        let header = "Fee Sheets ";
        let agentNames = "";

        feeSheets.forEach((item ,indx)=> {
          if(feeSheets.length == 1) {
            header +=  `<b>${item}</b>`;
          }
          else {
            header += (indx + 1) == feeSheets.length && feeSheets.length > 1 ?
               `and <b>${item}</b>`: `<b>${item}</b>, `;
          }
        });

        feeSheetGroup.forEach((item ,indx)=> {
          if(feeSheetGroup.length == 1) {
            agentNames +=  `<b>${item.AgentName}</b>`;
          }
          else {
            agentNames += (indx + 1) == feeSheetGroup.length && feeSheetGroup.length > 1 ?
               `and <b>${item.AgentName}</b>`: `<b>${item.AgentName}</b>, `;
          }
        });

        return header + ` ${feeSheets.length > 1 ? 'are' : 'is'}` + " to be sent to: <br />" + agentNames;
      });

      let dl = dialog.custom({
            title: "Fee Sheet Emailing Confirmation",
            messageHtml: toDisplay.join("<br /><br />"),
            buttons: [
              {
                text: "Send",
                onClick: (e) => {
                  return {result: true}
                }
              },
              {
                text: "Cancel",
                onClick: (e) => {
                  return {result: false}
                }
              }
            ]
          });

        let result =  await dl.show().then((dialogResult : any)=> dialogResult.result)
                      .catch((err: any) => false);

        return result;
    }


    async wizardContinue(){
        let canContinue = true;
        if(this.wizardStep == 2) {
          var dataSourceItems = _.cloneDeep((this.emailInsGrid as any).getDataSource().items());
          dataSourceItems.shift();

          if(!_.every(dataSourceItems, item => item.InstructionTemplateId && item.EmailTemplateId)) {
            await this.processDisplayMissingEmailAndFeeSheetId(dataSourceItems)
            return;
          }

          if(this.emailCCHasError) {
            await dialog.alert("Invalid Email in Email CC", 'Error');
            return;
          }

          if(await this.processConfirmationToSend(dataSourceItems)) {
            this.sendingInProgress = true;
            var jwtData = commonState.jwtData;
            var senderEmailAdd = jwtData.EmailAddress;
            var displayName = `${jwtData.GivenName} ${jwtData.Surname}`;
            var agentFeeSheets : SendAgentFeeSheetDto[] = [];

            _.forEach(dataSourceItems, item => {
              var agent = _.find(this.step1Selection, x => x.AgentName == item.AgentName);
              var agentFS : SendAgentFeeSheetDto = {
                 AgentName : item.AgentName,
                 FeeSheetIds : item.FeeSheetIds,
                 EmailTemplateId : item.EmailTemplateId,
                 InstructionTemplateId : item.InstructionTemplateId,
                 Email : agent.AgentEmail.split(';'),
                 Cc : this.selectedEmailCC, //Add the Email cc here 
                 AgentId : agent.AgentId
              }

              agentFeeSheets.push(agentFS);
            });

            var payload : SendFeeSheetDto = {
               SenderEmailAddress : senderEmailAdd,
               ClientName : this.ClientVal.ClientName,
               ClientId : this.ClientVal.ClientId,
               AgentFeeSheets : agentFeeSheets,
               TimeZoneOffset : (new Date()).getTimezoneOffset()
            }

            this.feeSheetService.sendFeesheets(payload)
                .then(success => {
                  var messageDisplay = dataSourceItems.length > 1 ? "Emails" : "Email";
                  this.emailCCSource = [];
                  this.selectedEmailCC = [];
                  notify(`${messageDisplay} successfully sent`, 'success', 4000);
                })
                .catch(error => {
                  notify('Failed to send email', 'error');
                })
                .finally(() => {
                  this.sendingInProgress = false;
                })
            
          }
          
        }
        else {
          if(this.wizardStep === 0) {
            canContinue = await this.processStep2Data(false);
          }
          else {
            canContinue = await this.processStep3Data();
          }
          if(canContinue) {
            this.wizardStep++;
            this.cancelOrBack = "Back";
            if(this.wizardStep != 2) {
              this.continueOrFinish = "Continue";
            }
            else {
              this.continueOrFinish = "Finish";
            }
            this.fromToolbarItem = true;
            this.wizardStepperComponent.option("selectedIndex", this.wizardStep)
          }
          
        }
    }

    wizardCancel() {
      if(this.wizardStep > 0) {
        this.wizardStep--;
        this.continueOrFinish = "Continue"
        if(this.wizardStep != 0) {
          this.cancelOrBack = "Back";
        }
        else {
          this.wizardStepperComponent.option("items[2].disabled", true);
          this.cancelOrBack = "Cancel";
        }

        this.fromToolbarItem = true;
        this.wizardStepperComponent.option("selectedIndex", this.wizardStep)
      }
      else {
        this.showingDialog = false;
      }
        
    }

    onPopUpHidden(e:any){
      this.duplicateCustomItem = "";
      this.selectedEmailCC =[];
      this.emailCCSource = [];
      this.wizardStep = 0;
      this.selectedRowInContextMenu = {
        data : false,
        prop : ""
      };
      this.agentsFeeSheets = [];
      this.feeSheetColumns = [];

    }

    onPopUpShowing(e:any) {
      this.wizardStepperComponent.option("selectedIndex", 0);
    }



    processJurisDictionDisplay(data: AgentInfoDto, jurisdictionType: JurisdictionType) : string {
      let result = "";      

      if(!data){
        return result;
      }

      if(jurisdictionType === JurisdictionType.In) {        
        if(data.Jurisdictions) {
          let filteredData = data.Jurisdictions.filter((item : ClientAgentJurisdictionDto) => item.InJurisdiction);
          filteredData.forEach((element : ClientAgentJurisdictionDto) => {
            result = (result ? `${result}, `: "") + element.Country.CountryCode;
          });    
        }    
      }
      else if(jurisdictionType === JurisdictionType.Out) {        
        if(data.Jurisdictions) {
          let filteredData = data.Jurisdictions.filter((item : ClientAgentJurisdictionDto) => !item.InJurisdiction);
          filteredData.forEach((element : ClientAgentJurisdictionDto) => {
            result = (result ? `${result}, `: "") + element.Country.CountryCode;
          });  
        }      
      }
      
      return result;
    }
}
